const constants = require("../constants");
const { CeloProvider } = require("@celo-tools/celo-ethers-wrapper");
const { providers } = require("ethers");

module.exports = async (rpcUrl) => {
  const defaultProvider = new providers.JsonRpcProvider(rpcUrl);
  const { chainId } = await defaultProvider.getNetwork();

  const networkName = constants.CHAINID_TO_NETWORK_NAME[chainId];

  let provider;
  if (networkName === "celo") provider = new CeloProvider(rpcUrl);
  else provider = new providers.JsonRpcProvider(rpcUrl);
  await provider.ready;

  return provider;
};
